export interface AuthCredentials {
  username: string
  password: string
}

export interface User {
  username: string
}

export enum AuthStatus {
  Error,
  Success,
  Pending,
}
